export const environment = {
  production: false,
  apiUrl: 'https://abacus-backend-dev.atlascopcorental.com/api/v1',
};
